import { defineMessages } from 'react-intl';

const messages = defineMessages({
  savedCareersTitle: {
    id: 'savedCareersTitle',
    defaultMessage: 'Saved careers',
    description: 'Title for the saved careers page.',
  },
  myCareersHeading: {
    id: 'myCareersTitle',
    defaultMessage: 'My careers',
    description: 'Heading for the saved careers header content.',
  },
  noSavedCareers: {
    id: 'noSavedCareers',
    defaultMessage: 'You have no saved careers.',
    description: 'Message displayed when there are no saved careers.',
  },
  noDefinedCategory: {
    id: 'noDefinedCategory',
    defaultMessage: 'Not defined',
    description:
      'Message displayed when there are no categories defined for a career.',
  },
  noDataAvailable: {
    id: 'noDataAvailable',
    defaultMessage: 'N/A',
    description: 'Text displayed when no information is available.',
  },
  registrationGateTitle: {
    id: 'registrationGateTitle',
    defaultMessage: 'You are not logged in',
    description: 'Title for the registration gate.',
  },
  registrationGateBody: {
    id: 'registrationGateBody',
    defaultMessage: 'Please log in to view your saved careers.',
    description: 'Body for the registration gate.',
  },
  careerTitle: {
    id: 'careerTitle',
    defaultMessage: 'Career',
    description: 'Title for the career column.',
  },
  requiredEducation: {
    id: 'requiredEducation',
    defaultMessage: 'Required education',
    description: 'Title for the required education column.',
  },
  averageSalary: {
    id: 'averageSalary',
    defaultMessage: 'Average salary',
    description: 'Title for the average salary column.',
  },
  cancelButtonText: {
    id: 'cancelButtonText',
    defaultMessage: 'Cancel',
    description: 'Text for the cancel button.',
  },
  removeButtonText: {
    id: 'removeButtonText',
    defaultMessage: 'Remove',
    description: 'Text for the remove button.',
  },
  removeCareerConfirmationText: {
    id: 'removeCareerConfirmationText',
    defaultMessage:
      'Are you sure you want to remove {careerName} from your saved careers?',
    description: 'Confirmation text before removing career from saved list',
  },
});

export default messages;
